import classNames from "classnames";
import { useTranslation } from "react-i18next";
import Carrier from "@Components/Carrier/Carrier";
import { DownIcon } from "src/assets/Icons";
import { useSSRContext } from "../../../context/SSRContext";
import { PassengerSelectionTile } from "../components";

export default function PassengerSelectionMob() {
  const { t } = useTranslation();
  const { cursor, passengerOptions, handleChange } = useSSRContext();

  const selectedPassenger = passengerOptions.find((p) => p.value === cursor.passengerId);

  return (
    <Carrier
      label={t("Flights.details.ssr.whosChoosing")}
      renderTrigger={({ open }) => (
        <div
          onClick={open}
          className="bg-background-minimal flex w-full cursor-pointer items-center gap-2 rounded-md p-2 px-4"
        >
          <div className="min-w-0 flex-1">
            <PassengerSelectionTile passenger={selectedPassenger} isActive />
          </div>
          <DownIcon className="text-font-subtle h-3 w-3 shrink-0" />
        </div>
      )}
      renderSheet={({ close }) => (
        <div className="flex flex-col gap-2 overflow-y-auto p-4 pb-6">
          {passengerOptions.map((passenger) => {
            const isActive = passenger.value === cursor.passengerId;
            return (
              <div
                key={passenger.value}
                onClick={() => {
                  handleChange("passengerId", passenger.value)();
                  close();
                }}
                className={classNames(
                  "bg-background-default flex cursor-pointer items-center rounded-xs p-4 outline-1 transition-all duration-300",
                  isActive ? "outline-border-active" : "outline-border-subtle outline-dashed",
                )}
              >
                <PassengerSelectionTile passenger={passenger} isActive={isActive} />
              </div>
            );
          })}
        </div>
      )}
    />
  );
}
